module.exports = __webpack_public_path__ + "img/logo-icon.85c7f547.png";